document.addEventListener('DOMContentLoaded', () => {
  const containerProduct = document.querySelector('.product__media-container');

  if (containerProduct) {
    const mobileDevice = window.matchMedia('(max-width: 768px)').matches;
    const desktopDevice = window.matchMedia('(min-width: 769px)').matches;

    const changeImage = (bigImage, smallImage) => {
      if (bigImage && smallImage) {
        const productImageMain = containerProduct.querySelectorAll('.product__media-item img')[0];
        const imageThumbnail = containerProduct.querySelectorAll('.product-thumbnails__item img')[0];
        const imageZoom = containerProduct.querySelectorAll('.product__media-item .lightbox-image ')[0];

        if (mobileDevice) {
          // Swap positions between image 1 and 2
          const productImageMainTwo = containerProduct.querySelectorAll('.product__media-item img')[1];
          const imageThumbnailTwo = containerProduct.querySelectorAll('.product-thumbnails__item img')[1];
          const imageZoomTwo = containerProduct.querySelectorAll('.product__media-item .lightbox-image ')[1];

          const imageMainChangeToTwoSrc = productImageMain.srcset;
          const imageMainThumbsToTwoSrc = imageThumbnail.src;

          imageZoomTwo.dataset.pswpSrc = imageMainChangeToTwoSrc;
          productImageMainTwo.src = imageMainChangeToTwoSrc;
          productImageMainTwo.srcset = imageMainChangeToTwoSrc;
          imageThumbnailTwo.src = imageMainThumbsToTwoSrc;
          imageThumbnailTwo.srcset = imageMainThumbsToTwoSrc;
        }

        // Change main image
        imageZoom.dataset.pswpSrc = bigImage;
        productImageMain.src = bigImage;
        productImageMain.srcset = bigImage;
        imageThumbnail.src = smallImage;
        imageThumbnail.srcset = smallImage;
      }
    }

    // Desktop Image
    if (desktopDevice) {
      const newDesktopMainImage = containerProduct.dataset.imageProductv2Desk;
      const newDesktopThumbImage = containerProduct.dataset.imageThumbv2Desk;
      changeImage(newDesktopMainImage, newDesktopThumbImage);
    }

    // Mobile Image
    if (mobileDevice) {
      const newMobileMainImage = containerProduct.dataset.imageProductv2;
      const newMobileThumbImage = containerProduct.dataset.imageThumbv2;
      changeImage(newMobileMainImage, newMobileThumbImage);
    }
  }
})